module.exports = __webpack_public_path__ + "img/dark_checkin_at_airport.7bbbae6a.png";